import React from 'react'
import { css, cx } from '@emotion/css'

const tooltipListCss = css`
  list-style-type: none;
  padding: 0;
  margin: 0;
`

interface Props {
  children: any
  className?: string
}

export function TooltipList({ children, className }: Props) {
  return <ul className={cx(tooltipListCss, className)}>{children}</ul>
}
